module.exports = __webpack_public_path__ + "i18n/zh-CN.49add8506a79bcdaa0c15130e759fa91.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1317
// module chunks = 59